export default "__VITE_ASSET__DKYIy8kv__"